import { apiSlice } from "../api/apiSlice";
import { membersApi } from "../members/membersApi";

export const teamsApi = apiSlice.injectEndpoints({
    tagTypes: ["Teams"],
    endpoints: (builder) => ({
        getTeams: builder.query({
            query: (data) => {
                let queryString = "";
                queryString =
                    data?.length > 0
                        ? data?.map((tId) => `id=${tId}`).join("&")
                        : "";
                if (queryString) return `/teams?${queryString}`;
                else return " `/teams?id=null";
            },
            refetchOnMountOrArgChange: true,
            providesTags: ["Teams"],
        }),
        getTeam: builder.query({
            query: (name) => {
                return `/teams?name=${name.toLowerCase()}`;
            },
            refetchOnMountOrArgChange: true,
        }),
        addTeam: builder.mutation({
            query: (data) => ({
                url: "/teams",
                method: "POST",
                body: {
                    name: data.name.toLowerCase(),
                    description: data.description,
                    color: data.color,
                    timestamp: data.timestamp,
                },
            }),
            invalidatesTags: ["Teams"],

            async onQueryStarted(arg, { queryFulfilled, dispatch }) {
                const team = await queryFulfilled;
                if (team?.data?.id) {
                    dispatch(
                        membersApi.endpoints.addMember.initiate({
                            email: arg.user.email,
                            name: arg.user.name,
                            isCreator: true,
                            teamId: team?.data?.id,
                        })
                    );
                }
            },
        }),
        // editTeam: builder.mutation({
        //     query: ({ id, data, sender }) => ({
        //         url: `/teams/${id}`,
        //         method: "PATCH",
        //         body: data,
        //     }),
        // }),
        deleteTeam: builder.mutation({
            query: (id) => ({
                url: `/teams/${id}`,
                method: "DELETE",
            }),
            invalidatesTags: ["UserTeams"],
        }),
    }),
});

export const {
    useGetTeamsQuery,
    useGetTeamQuery,
    useAddTeamMutation,
    useDeleteTeamMutation,
} = teamsApi;
